<template>
  <div class="no_cont">
    <p>신청한 마이팩이 없습니다.</p>
    <p>나를 위한 나의 선택,<br><strong>마이팩을 만들어보세요.</strong></p>
    <button
      type="button"
      class="btn_default-b medium"
      @click="onClick"
    >
      마이팩 만들기
    </button>
  </div>
</template>

<script>
import { CONTEXT_TYPE } from '@/utils/constants';
import compositionHelpers from '@/utils/helpers/composition';

export default {
  name: 'MypackNoContent',
  methods: {
    onClick() {
      const ctx = compositionHelpers.createEmptyContext();
      compositionHelpers.updateContext(this.$store, ctx);
      this.$router.push(`/agreement/${CONTEXT_TYPE.COMPOSITION}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/mypacks/main/partial/MypackNoContent.vue